export default __webpack_public_path__ + "/assets/images/fontawesome-webfont.svg";